import { render, staticRenderFns } from "./tableDoubleColumn.vue?vue&type=template&id=6648a220"
import script from "./tableDoubleColumn.vue?vue&type=script&lang=js"
export * from "./tableDoubleColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports